module.exports = __webpack_public_path__ + "static/media/create_funnel_sample_en.8e31302c.png";